import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Config from '../../config';
import Form from '../../view/form';
import TypeGroup from '../../model/type.group';
import TypeGroups from '../../collection/type.groups';

import { ask, } from '../../utils/popups';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/type.groups.list',

    url() {
        return 'types/groups';
    },

    open() {
        const form = new Form( {
            template: 'module/refbooks/type.groups.form',
            clusters: this.options.clusters,
        } );

        const makeDisableUpdateDedelePredicate = privilegeCode => 
            () =>
                !Config.privileges().includes( privilegeCode ) ||
                !['GLOBAL', 'CLUSTER'].includes( Config.level() ) ||

                // Роль уровня кластера может редактировать/удалять только сущности своего кластера;
                // в списке уже только "мои" сущности, но с примесью глобальных;
                // поэтому достаточно только запретить редактировать глобальные
                Config.level() === 'CLUSTER' && 
                    !this.options.paged.current().get( 'cluster' );

        const actions = this.options.actions = {
            
            defaults: 'edit',

            create: {

                disabled: () =>
                    !Config.privileges().includes( 'create_type' ) ||
                    !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler: () => {
                    const current = new TypeGroup();
                    const binding = form.bind( current );
                    binding.then( () => {
                        if (this.state().cluster && this.state().cluster.id != -1)
                            current.set( 'cluster', this.state().cluster );
                        else if (Config.level() === 'CLUSTER')
                            current.set( 'cluster', Config.cluster() );
                    } );
        
                    ask( binding,
                        'type::modal new type group - title', 'actions::create', 'actions::cancel', 
                        () => this.options.typeGroups.save( form ) )
                            .then( () => this.options.source.reset(
                                this.options.typeGroups.models,
                                { silent: true } // a sort of paranoia
                            ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
                },
                
            }, 

            edit: {

                disabled: makeDisableUpdateDedelePredicate( 'update_type' ),

                handler: current =>
                    ask( form.bind( current.clone() ),
                        'type::modal edit type group - title', 'actions::save', 'actions::close', 
                        () => this.options.source.save( form ) )
                            .then( () => this.sort() )
                            .then( () => this.render() ),

            },
            
            destroy: {
            
                disabled: makeDisableUpdateDedelePredicate( 'delete_type' ),

                handler: current =>
                    this.destroy( current, 
                        'type::modal delete type group - title', 
                        'type::modal delete type group - confirmation text' ),

            },
            
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )

        this.options.source = new TypeGroups( this.options.typeGroups.models );
        this.options.sorted = new TypeGroups();
        this.options.filtered = new TypeGroups();
        this.options.paged = new TypeGroups( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/type.groups.list.js